module.exports = __webpack_public_path__ + "static/media/et-login-left-banner.e7319832.svg";